module.exports = __webpack_public_path__ + "static/media/wagashi-assortment.88a6d234.jpg";